'use client';

import ArrowMinimal from '@/assets/svg/ArrowMinimal';
import ArrowSharpMinimal from '@/assets/svg/ArrowSharpMinimal';
import { cn } from '@/lib/utils';
import { PlusCircledIcon } from '@radix-ui/react-icons';
import { a, useSpring } from '@react-spring/web';
import { PlusCircle } from 'lucide-react';
import { PropsWithChildren, useState } from 'react';
import { BsFillPlusCircleFill } from 'react-icons/bs';
import useMeasure from 'react-use-measure';

interface Props {
  question: string;
  answer?: string;
  className?: string;
  offset?: number;
}

export default function ({ question, answer, className, offset }: Props) {
  const [opened, setOpened] = useState(false);
  const [ref, { height }] = useMeasure();

  const elementStyle = useSpring({
    height: !opened ? 0 : height,
    opacity: !opened ? 0 : 1,
  });

  const arrowStyle = useSpring({
    rotate: opened ? -135 : 0,
    scale: 1.5,
    transformOrigin: 'center',
    width: "1em",
    height: "1em",
  });

  return (
    <div
      className={cn('border-b py-5 sm:!pl-0 cursor-pointer border-[#0D1524]', className)}
      onClick={() => !!answer && setOpened(!opened)}
    >
      <div className='flex justify-between items-end w-full'>
        <p className='2xl:text-[30px] text-[20px] sm:text-[20px] sm:align-middle dynamic-desc__text mb-0'>
          {question}
        </p>
        {answer && (
          <a.div style={arrowStyle}>
            <BsFillPlusCircleFill />
          </a.div>
        )}
      </div>
      {answer && (
        <a.div
          style={elementStyle}
          className={cn({
            'pointer-events-none': !opened,
          })}
        >
          <div ref={ref}>
            <p className='font-poppins 2xl:text-[20px] text-[13px] pt-5 leading-[120%] dynamic-desc__text'>
              {answer}
            </p>
          </div>
        </a.div>
      )}
    </div>
  );
}
